import { Intent, Tag } from '@pinpointhq/thumbtack';
import * as React from 'react';

export interface IFile {
  name: string;
  path?: string;
  id?: string;
  signedId?: string;
}

interface IFileDisplayProps {
  file: IFile;
  name: string;
  handleRemove?: ((file: IFile) => void) | null;
}

function generateRandomString(length = 8): string {
  return Array.from({ length }, () => 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'[Math.floor(Math.random() * 62)]).join('');
}

export function FileDisplay({ file, name, handleRemove }: IFileDisplayProps) {
  if (!file) return null;

  const onRemove = handleRemove ? () => handleRemove(file) : null;
  const displayName = file.name || `file_${generateRandomString()}`;

  function renderHiddenInput() {
    if (!file.signedId) return null;

    return <input type="hidden" name={name} id={name} value={file.signedId} />;
  }

  return (
    <div>
      <Tag minimal={true} onRemove={onRemove} round={true} intent={Intent.SUCCESS}>
        <div>
          <a href={file.path} target="_blank" className="link" rel="noreferrer" title={displayName}>
            {displayName.substring(0, 60)}
          </a>
          {renderHiddenInput()}
        </div>
      </Tag>
    </div>
  );
}
